$(document).ready(function(){
//   Product Slider
  $('.custom_main_images_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow:'<button class="custom_arrow_next"><i class="fa-solid fa-angle-right"></i></button>',
    prevArrow:'<button class="custom_arrow_prev"><i class="fa-solid fa-angle-left"></i></button>',
    asNavFor: '.custom_thumb_images_slider'
  });
  $('.custom_thumb_images_slider').slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    asNavFor: '.custom_main_images_slider',
    dots: false,
    nextArrow:'<button class="custom_arrow_next"><i class="fa-solid fa-angle-right"></i></button>',
    prevArrow:'<button class="custom_arrow_prev"><i class="fa-solid fa-angle-left"></i></button>',
    centerMode: true,
    arrows: true,
    focusOnSelect: true
  });
  //   Product Slider end
  var data_link = $("select#ContactForm-products").find("option:selected").attr("data-href");
   $("input#ContactForm-productsurls").val(data_link);
});

$("select#ContactForm-products").change(function(){
  var data_link = $(this).find("option:selected").attr("data-href");
 $("input#ContactForm-productsurls").val(data_link);
});
// Show the first tab and hide the rest Product Page tabs
$('ul.tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();
// Click function
$('ul.tabs-nav li').click(function(){
  $('ul.tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();

  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

// Product Page tabs end

$(document).on("click",".spr-stars",function(){
    $('html, body').animate({
        scrollTop: $("ul.tabs-nav").offset().top
    }, 1000);
   setTimeout(function(){
       $("li.product_reviews_tab a").trigger("click");
   },1200);
})